/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactusContent } from '../../models/contactus-content';
import { CriteriaContentObject } from '../../models/criteria-content-object';

export interface ApiMasterContactusContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterContactusContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterContactusContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactusContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContactusContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactusContent>>;
    })
  );
}

apiMasterContactusContentGetByCriteriaPost.PATH = '/api/Master/ContactusContent/GetByCriteria';
